export const styles = {
  row: {
    padding: '4px 0px',
    display: 'flex',
    justifyContent: 'space-between',
    margin: 0,
  },
  col: (align = 'center') => ({
    padding: 0,
    display: 'flex',
    justifyContent: align,
  }),
  contentWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  iconWrapper: {
    marginRight: 8,
  },
  wrapper: {
    borderRadius: 8,
    border: '1px solid #E2E2FC',
    marginBottom: 10,
  },
  label: {
    color: '#707087',
    fontSize: 14,
    fontWeight: 700,
  },
  value: {
    color: '#707087',
    fontFamily: 'Proxima Nova',
    fontSize: 16,
    fontWeight: 400,
  },
}
